import { call, put } from 'redux-saga/effects';

import api from 'api';
import { IUserWebAnalyticsResponse } from 'api/components/User/types';

import { getUserWebAnalyticsError, getUserWebAnalyticsSuccess } from '../actions';

export function* getUserWebAnalytics() {
    try {
        const response: IUserWebAnalyticsResponse = yield call(api.user.getUserWebAnalytics);

        yield put(getUserWebAnalyticsSuccess(response));
    } catch (error) {
        yield put(getUserWebAnalyticsError());
    }
}
